var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    '--current-font-family': _vm.$store.state.style.currentFontFamily,
    '--launch-text': _vm.$store.state.style.launchText,
    '--launch-gradient-top': _vm.$store.state.style.launchGradientTop,
    '--launch-gradient-bottom': _vm.$store.state.style.launchGradientBottom,
    '--maintenance-logo': _vm.$store.state.style.maintenanceLogo,
    '--maintenance-gradient-top': _vm.$store.state.style.maintenanceGradientTop,
    '--maintenance-gradient-bottom': _vm.$store.state.style.maintenanceGradientBottom,
    '--error-header-text': _vm.$store.state.style.errorHeaderText,
    '--error-header-color': _vm.$store.state.style.errorHeaderColor,
    '--button-focus': _vm.$store.state.style.buttonFocus,
    '--typical-button-text': _vm.$store.state.style.typicalButtonText,
    '--typical-button-enabled': _vm.$store.state.style.typicalButtonEnabled,
    '--typical-button-hover': _vm.$store.state.style.typicalButtonHover,
    '--typical-button-active': _vm.$store.state.style.typicalButtonActive,
    '--typical-button-disabled': _vm.$store.state.style.typicalButtonDisabled,
    '--negative-button-enabled': _vm.$store.state.style.negativeButtonEnabled,
    '--negative-button-hover': _vm.$store.state.style.negativeButtonHover,
    '--negative-button-active': _vm.$store.state.style.negativeButtonActive,
    '--danger': _vm.$store.state.style.danger,
    '--danger-pale': _vm.$store.state.style.dangerPale,
    '--danger-light': _vm.$store.state.style.dangerLight,
    '--shooting-button-hover': _vm.$store.state.style.shootingButtonHover,
    '--shooting-button-active': _vm.$store.state.style.shootingButtonActive,
    /**
     * UIカスタマイズ
     * @see https://liquidinc.atlassian.net/browse/EKYCDEV-3636
     */
    ..._vm.customStyleVariables
  }),attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }